import styled from 'styled-components'

// Cancels .ctp-dashboard-building-container's 10px 5px padding so the iframe is full-bleed,
// same trick as asset-tracking.scss.
export const Container = styled.div`
  margin: -10px -5px 0;
  height: calc(100% + 10px);
  display: flex;
  flex-direction: column;
`

export const Iframe = styled.iframe`
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
`
